<template lang="html">
  <card class="records-view">
    <template slot="header">
      <card-controls :back="false">
        <span slot="actions">
          <n-button
            type="primary"
            simple=""
            @click.native="createNewRecord()">
            <i class="fas fa-plus-circle" />
            Registrar Poda
          </n-button>
          <n-button
            v-if="!components.globalFilter"
            type="primary"
            simple=""
            @click.native="components.globalFilter = true">
            <i class="fal fa-filter"/>
          </n-button>
          <n-button
            v-if="components.globalFilter"
            type="danger"
            simple=""
            @click.native="handleCloseFilter()">
            <i class="fal fa-filter"/>
          </n-button>
          <n-button
            type="primary"
            simple=""
            @click.native="goToDiagram">
            <i class="fal fa-project-diagram"/>
          </n-button>
        </span>
      </card-controls>

      <h4 class="card-title"><b>Podas</b></h4>
    </template>


    <div v-loading="loader">
      <global-filter
        v-if="components.globalFilter"
        :records="records"
        :sectors="sectors"
        @close="handleCloseFilter"
        @applyFilter="applyFilter"/>

      <record-groups
        v-if="!loader"
        :records="records"
        :show-all-tab="showAllTab"/>
    </div>

  </card>
</template>

<script>
import RecordGroups from "./Components/PruningGroups"
import GlobalFilter from "./Components/GlobalFilter"
export default {
    components: {
        RecordGroups,
        GlobalFilter
    },
    data() {
        return {
            getRecordsMethod: "getPrunings",
            loader: true,
            sectors: [],
            records: [],
            showAllTab: false,
            components: {
                globalFilter: false
            }
        }
    },
    created() {
        this.getRecords()
    },
    methods: {
        createNewRecord() {
            this.$router.push({
                name: "tasklist-start-process",
                params: {
                    id: "pruning"
                }
            })
        },
        getRecords(filter) {
            let vm = this
            vm.showAllTab = false
            let farm_id = this.$store.getters["Farms/GET_FARM"]._id.$oid
            this.Services.Prunings.getPrunings(farm_id, filter)
                .then(response => {
                    vm.records = response.data
                    vm.showAllTab = filter != undefined ? true : false
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    vm.loader = false
                })
        },
        handleCloseFilter() {
            this.components.globalFilter = false
            this.getRecords()
        },
        applyFilter(query) {
            this.loader = true
            this.getRecords(query)
        },
        goToDiagram() {
            this.$router.push({
                name: "diagram",
                params: {
                    processKey: "pruning",
                    state: "new",
                    backTarget: "prunings"
                }
            })
        }
    }
}
</script>

<style lang="sass" scoped>
    .records-view
        min-height: 200px
</style>
